import { GenderMaleIcon } from './GenderMaleIcon';

/**
 * author: Austin Andrews
 * id 78C91AE2-F79B-48EF-9CCD-5E6874BA20CA
 * name gender-male
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gender-male.svg
 * tags
 */
export const MarsIcon = GenderMaleIcon;
export default MarsIcon